import React, { useState, useEffect } from "react";
import { FiCompass } from "react-icons/fi";
import AIConciergeDrawer from "./AIConciergeDrawer";
import "./AIConcierge.css";

export default function AIConciergeButton() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener("open-ai-concierge", handleOpen);
    return () => window.removeEventListener("open-ai-concierge", handleOpen);
  }, []);

  return (
    <>
      <button
        className="sw-ai-floating-btn"
        onClick={() => setIsOpen(true)}
        aria-label="Open SoloWay AI Concierge"
        title="SoloWay AI Travel Concierge & Support"
      >
        <div className="btn-icon-pulse">
          <span className="pulse-ring" />
          <FiCompass />
        </div>
        <span className="btn-label">AI Concierge</span>
      </button>

      <AIConciergeDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
